import { useLang } from "../../context/LanguageContext";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";

export default function FAQ() {
  const { t } = useLang();
  return (
    <section data-testid="faq-section" className="section-pad bg-[hsl(var(--background))]">
      <div className="container-x">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="overline mb-5">{t.faq.eyebrow}</div>
            <h2 className="font-serif font-light text-4xl sm:text-5xl md:text-6xl leading-[1.02] tracking-tight text-[hsl(var(--foreground))]">
              {t.faq.title}
            </h2>
          </div>
          <div className="lg:col-span-7">
            <Accordion type="single" collapsible className="w-full">
              {t.faq.items.map((it, i) => (
                <AccordionItem key={i} value={`q-${i}`} className="border-b border-[hsl(var(--foreground))]/12" data-testid={`faq-item-${i}`}>
                  <AccordionTrigger className="text-left font-serif text-xl md:text-2xl text-[hsl(var(--foreground))] py-6 hover:text-[hsl(var(--accent))]">
                    {it.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-base text-[hsl(var(--foreground))]/85 leading-relaxed pb-8">
                    {it.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
